import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { provideComponentStore } from '@ngrx/component-store';
import { PdBankDataStore } from './pd-bank-data.store';
import { PdBankData } from '../pd-collect-data.store';

@Component({
  selector: 'app-pd-bank-data',
  templateUrl: './pd-bank-data.component.html',
  providers: [provideComponentStore(PdBankDataStore)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdBankDataComponent {
  @Input() set data(data: PdBankData | undefined | null) {
    if (data) {
      this.formGroup.patchValue({
        website: data.website,
        businessActivity: data.businessType,
        bankCode: data.bankCode,
        bankBranch: data.bankBranch,
        bankAccount: data.bankAccount,
      });
    }
  }

  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<PdBankData>();

  public formGroup = new FormGroup({
    website: new FormControl<string>(''),
    businessActivity: new FormControl<number | null>(null),
    bankCode: new FormControl<number | null>(null),
    bankBranch: new FormControl<string>(''),
    bankAccount: new FormControl<string>(''),
  });

  constructor(public readonly cs: PdBankDataStore) {}

  public submit() {
    this.next.emit({
      website: this.formGroup.get('website')!.value,
      businessType: this.formGroup.get('businessActivity')!.value,
      bankCode: this.formGroup.get('bankCode')!.value,
      bankBranch: this.formGroup.get('bankBranch')!.value,
      bankAccount: this.formGroup.get('bankAccount')!.value,
    });
  }

  public goBack() {
    this.back.emit();
  }
}
